<template>
    <div class="about-area pb-100">
        <div class="container-fluid">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-12">
                    <div class="about-img">
                        <img src="../../assets/images/about/about5.png" alt="image">
                        <div class="shape"><img src="../../assets/images/about/about-shape1.png"></div>
                    </div>
                </div>

                <div class="col-lg-6 col-md-12">
                    <div class="about-content">
                        <div class="content">
                            <span class="sub-title"><img src="../../assets/images/star-icon.png" alt="image"> About Us</span>
                            <h2>Business Analytics For Data-Driven Solutions</h2>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.</p>
                            <ul class="about-list">
                                <li>
                                    <span>
                                        <div class="icon">
                                            <i class="flaticon-tick"></i>
                                        </div>
                                        Big Data
                                        <img src="../../assets/images/our-mission/our-mission-shape2.png" alt="image">
                                    </span>
                                </li>
                                <li>
                                    <span>
                                        <div class="icon">
                                            <i class="flaticon-tick"></i>
                                        </div>
                                        Data Visualization
                                        <img src="../../assets/images/our-mission/our-mission-shape2.png" alt="image">
                                    </span>
                                </li>
                                <li>
                                    <span>
                                        <div class="icon">
                                            <i class="flaticon-tick"></i>
                                        </div>
                                        Data Warehousing
                                        <img src="../../assets/images/our-mission/our-mission-shape2.png" alt="image">
                                    </span>
                                </li>
                                <li>
                                    <span>
                                        <div class="icon">
                                            <i class="flaticon-tick"></i>
                                        </div>
                                        Data Management
                                        <img src="../../assets/images/our-mission/our-mission-shape2.png" alt="image">
                                    </span>
                                </li>
                                <li>
                                    <span>
                                        <div class="icon">
                                            <i class="flaticon-tick"></i>
                                        </div>
                                        Business Intelligence
                                        <img src="../../assets/images/our-mission/our-mission-shape2.png" alt="image">
                                    </span>
                                </li>
                                <li>
                                    <span>
                                        <div class="icon">
                                            <i class="flaticon-tick"></i>
                                        </div>
                                        Business Intelligence
                                        <img src="../../assets/images/our-mission/our-mission-shape2.png" alt="image">
                                    </span>
                                </li>
                            </ul>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.</p>
                            <router-link to="/about-us-two" class="default-btn"><i class="flaticon-right"></i>More About Us<span></span></router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'BusinessAnalytics'
}
</script>